import * as React from 'react'

import * as S from '../../../../styles'

import * as select from '../../../../behaviours/select'
import { scrollContext } from '../context'
import * as icons from '../../../../svg/icons'

type SelectDrawerProps = {
  isOpen: boolean
  id: string
  height?: number
  scrollRef: React.RefObject<HTMLUListElement>
  navigableRegister: select.SelectApi['navigableRegister']
  deregister: select.SelectApi['deregister']
  register: select.SelectApi['register']
  children?: React.ReactNode
  multiple?: boolean
  filterable?: boolean
  filter: string
  onFilter: (filter: string) => void
  filterPlaceholder?: string
  close: () => void
  label: React.ReactNode
}

export function SelectDrawer({
  isOpen,
  id,
  height,
  scrollRef,
  navigableRegister,
  deregister,
  register,
  children,
  multiple,
  close,
  filterable,
  label,
}: SelectDrawerProps): React.ReactElement<SelectDrawerProps> {
  if (filterable === true) {
    throw Error('not implemented')
  }
  if (multiple === true) {
    throw Error('not implemented')
  }

  return (
    <>
      <S.form.select.ResponsiveDrawer isOpen={isOpen}>
        <S.form.select.DrawerHead>
          <S.heading.TitleCard>{label}</S.heading.TitleCard>
          <S.button.UnstyledButton onClick={close}>
            <icons.Cross size={20} />
          </S.button.UnstyledButton>
        </S.form.select.DrawerHead>
        <S.dropdown.Dropdown>
          <S.form.select.ScrollList height={height} ref={scrollRef} tabIndex={-1} aria-labelledby={id} role="listbox">
            <scrollContext.Provider value={scrollRef}>
              <select.SelectContextProvider value={{ navigableRegister, deregister, register }}>
                {children}
              </select.SelectContextProvider>
            </scrollContext.Provider>
          </S.form.select.ScrollList>
        </S.dropdown.Dropdown>
      </S.form.select.ResponsiveDrawer>
    </>
  )
}
